import type { Api, Stat } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function carsforsaleImport(): Promise<Api.Result<Stat.CarsforsaleImport>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/stat/carsforsale-import`, {
      method: 'GET',
      headers,
      next: { revalidate: 5 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
